import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrgsetupComponent } from './orgsetup/orgsetup.component';
import { DepartmentComponent } from './department/department.component';
import { EntityComponent } from './entity/entity.component';
import { VerticalComponent } from './vertical/vertical.component';
import { LocationComponent } from './location/location.component';
import { UsersComponent } from './users/users.component';
import { MainLayoutComponent } from './main-layout.component';
import { RegionComponent } from './region/region.component';
import { HubComponent } from './hub/hub.component';
import { CityComponent } from './city/city.component';
import { ApplicationconfigurationComponent } from './applicationconfiguration/applicationconfiguration.component';
import { CountryComponent } from './country/country.component';
import { UseraccessmappingComponent } from './useraccessmapping/useraccessmapping.component';
import { SubdepartmentComponent } from './subdepartment/subdepartment.component';
import { SubverticalComponent } from './subvertical/subvertical.component';
import { EntitytypeComponent } from './entitytype/entitytype.component';
import { StateComponent } from './state/state.component';
import { LocationtypeComponent } from './locationtype/locationtype.component';
import { CurrencyComponent } from './currency/currency.component';
import { OrganisationComponent } from './organisation/organisation.component';
import { userLogComponent } from './userLog/userLog.component';
import { SchedularLogComponent } from './schedularlog/schedularLog.component';
import { CommonmastersauditlogComponent } from './commonmastersauditlog/commonmastersauditlog.component';
import { ClientgroupComponent } from './clientgroup/clientgroup.component';
import { FinancialyearComponent } from './financialyear/financialyear.component';
import { MycredentialsComponent } from './mycredentials/mycredentials.component';
import { DefaultRouteGaurdGuard } from 'src/app/gaurd/default-route-gaurd.guard';
import { CommondashboardComponent } from './commondashboard/commondashboard.component';
import { UnlicenseduserComponent } from './unlicenseduser/unlicenseduser.component';
import { MyconfigurationComponent } from './myconfiguration/myconfiguration.component';
import { LoginpagemessagesComponent } from './loginpagemessages/loginpagemessages.component';
import { OrganisationstatisticsComponent } from './organisationstatistics/organisationstatistics.component';
import { ClientusagereportComponent } from './clientusagereport/clientusagereport.component';
import { SignatorydetailsComponent } from './signatorydetails/signatorydetails.component';
import { EsignhomeComponent } from './esignhome/esignhome.component';
import { RemoveorganisationComponent } from './removeorganisation/removeorganisation.component';
import { UserhelpComponent } from './userhelp/userhelp.component'; 
import { InvalidfileextensionsComponent } from './invalidfileextensions/invalidfileextensions.component';
import { HelpmasterComponent } from './helpmaster/helpmaster.component';
import { VersionupdateComponent } from './versionupdate/versionupdate.component';
import { RolegaurdGuard } from 'src/app/gaurd/rolegaurd.guard';
import { ApplicationlogsComponent } from './applicationlogs/applicationlogs.component';
const routes: Routes = [
  {
    path: '', component: MainLayoutComponent,
    children: [
      { path: 'common/setup', component: OrgsetupComponent },
      { path: 'common/department', component: DepartmentComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/sub-department', component: SubdepartmentComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/entity', component: EntityComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/entity-type', component: EntitytypeComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/vertical', component: VerticalComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/sub-vertical', component: SubverticalComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/location', component: LocationComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/location-type', component: LocationtypeComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/user', component: UsersComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/region', component: RegionComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/hub', component: HubComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/city', component: CityComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/country', component: CountryComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/state', component: StateComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/currency', component: CurrencyComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/application-configuration', component: ApplicationconfigurationComponent,canActivate:[RolegaurdGuard]  },
      { path: 'set-up', component: OrgsetupComponent },
      { path: 'common/user-access-mapping', component: UseraccessmappingComponent,canActivate:[RolegaurdGuard]  },
      { path: 'common/organisation', component: OrganisationComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/user-log-report', component: userLogComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/schedulerlog', component: SchedularLogComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/audit-log', component: CommonmastersauditlogComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/client-group', component: ClientgroupComponent,canActivate:[RolegaurdGuard]  },
      { path: 'common/financial-year', component: FinancialyearComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/my-credentials', component: MycredentialsComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/common-dashboard', component: CommondashboardComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/unlicensed-user-master', component: UnlicenseduserComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/my-configuration', component: MyconfigurationComponent ,canActivate:[RolegaurdGuard] },
      { path: 'common/login-page-messages', component: LoginpagemessagesComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/organisation-statistics', component: OrganisationstatisticsComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/client-usage-report', component: ClientusagereportComponent,canActivate:[RolegaurdGuard]  },
      { path: 'common/signatory-details', component: SignatorydetailsComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/e-signature', component: EsignhomeComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/remove-organisation', component: RemoveorganisationComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/help', component: UserhelpComponent },
      { path: 'common/invalid-file-extensions', component: InvalidfileextensionsComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/help-masters', component: HelpmasterComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/version-update-report', component: VersionupdateComponent,canActivate:[RolegaurdGuard] },
      { path: 'common/application-logs', component: ApplicationlogsComponent,canActivate:[RolegaurdGuard]  },
      { path: '', canActivate: [DefaultRouteGaurdGuard] }
      // { path:'' , redirectTo:'common/user', pathMatch:'full'}

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainLayoutRoutingModule {
}
